import * as React from "react";
import styles from "./section1.module.scss";
import Image from "next/image";
import Drawings from "@public/assets/images/bg-drawing.png";
import Button from "@components/Button";
import Arrow from "@public/assets/icons/orange-curve-arrow.svg";
import { gsap } from "gsap";

const VendorsSection1: React.FC = () => {
  let leftRef = React.useRef<Array<HTMLDivElement | null>>([]);
  let rightRef = React.useRef<Array<HTMLDivElement | null>>([]);
  let arrowRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    let currentLeftRef = leftRef.current;
    let currentRightRef = rightRef.current;
    let currentArrowRef = arrowRef.current as GSAPTweenTarget;

    gsap.defaults({ ease: "Power4.out" });

    let tl1 = gsap.timeline({
      scrollTrigger: {
        trigger: currentRightRef,
        start: "top 60%",
        // markers: process.env.NODE_ENV === "development" ? true : false
      },
    });

    let tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: currentLeftRef,
        start: "top 50%",
        // markers: process.env.NODE_ENV === "development" ? true : false
      },
    });

    tl1.staggerFromTo(
      currentRightRef,
      1,
      { autoAlpha: 0, y: 40 },
      { autoAlpha: 1, y: 0 },
      0.15
    );

    tl2
      .staggerFromTo(
        currentLeftRef,
        1,
        { autoAlpha: 0, y: 40 },
        { autoAlpha: 1, y: 0 },
        0.15
      )
      .fromTo(
        currentArrowRef,
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)",
        },
        {
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        }
      );
  }, []);

  return (
    <section className={styles["section1"]}>
      <div className={styles["section1__bg"]}>
        <div className={styles["section1__bg__soft"]}>
          <Image
            alt="pencil drawings"
            src={Drawings}
            placeholder="blur"
            objectFit="cover"
            objectPosition="center"
            priority
            quality={100}
            layout="fill"
          />
        </div>
      </div>
      <div className={styles["section1__bg__two"]} />
      <div className={styles["section1__container"]}>
        <div className={styles["section1__first"]}>
          <div className={styles["section1__first__hidden"]}>
            <div
              className={styles["section1__first__text"]}
              ref={(element) => {
                leftRef.current[0] = element;
              }}
            >
              Our vendors platform is
            </div>
          </div>
          <div className={styles["section1__first__hidden"]}>
            <div
              className={styles["section1__first__text"]}
              ref={(element) => {
                leftRef.current[1] = element;
              }}
            >
              designed to give each{" "}
            </div>
          </div>{" "}
          <div className={styles["section1__first__hidden"]}>
            <div
              className={styles["section1__first__text"]}
              ref={(element) => {
                leftRef.current[2] = element;
              }}
            >
              business an opportunity{" "}
            </div>
          </div>{" "}
          <div className={styles["section1__first__hidden"]}>
            <div
              className={styles["section1__first__text"]}
              ref={(element) => {
                leftRef.current[3] = element;
              }}
            >
              to reach a wide range{" "}
            </div>
          </div>{" "}
          <div className={styles["section1__first__hidden"]}>
            <div
              className={styles["section1__first__text"]}
              ref={(element) => {
                leftRef.current[4] = element;
              }}
            >
              of users, potential event{" "}
            </div>
          </div>{" "}
          <div className={styles["section1__first__hidden"]}>
            <div
              className={styles["section1__first__text"]}
              ref={(element) => {
                leftRef.current[5] = element;
              }}
            >
              owners and build a{" "}
            </div>
          </div>
          <div className={styles["section1__first__hidden"]}>
            <div
              className={styles["section1__first__text"]}
              ref={(element) => {
                leftRef.current[6] = element;
              }}
            >
              profitable relationship{" "}
            </div>
          </div>
          <div className={styles["section1__first__hidden"]}>
            <div
              className={styles["section1__first__text"]}
              ref={(element) => {
                leftRef.current[7] = element;
              }}
            >
              with them.
            </div>
          </div>
        </div>
        <div ref={arrowRef} className={styles["section1__arrow"]}>
          <Arrow />
        </div>

        <div className={styles["section1__second"]}>
          <div className={styles["section1__second__hidden"]}>
            <div
              className={styles["section1__second__text"]}
              ref={(element) => {
                rightRef.current[0] = element;
              }}
            >
              Join to get the best visibility for
            </div>
          </div>
          <div className={styles["section1__second__hidden"]}>
            <div
              className={styles["section1__second__text"]}
              ref={(element) => {
                rightRef.current[1] = element;
              }}
            >
              your business and reach a
            </div>
          </div>{" "}
          <div className={styles["section1__second__hidden"]}>
            <div
              className={styles["section1__second__text"]}
              ref={(element) => {
                rightRef.current[2] = element;
              }}
            >
              {" "}
              wide range of event{" "}
            </div>
          </div>{" "}
          <div className={styles["section1__second__hidden"]}>
            <div
              className={styles["section1__second__text"]}
              ref={(element) => {
                rightRef.current[3] = element;
              }}
            >
              owners
            </div>
          </div>{" "}
          <div className={styles["section1__second__hidden"]}>
            <div
              className={styles["section1__second__button"]}
              ref={(element) => {
                rightRef.current[4] = element;
              }}
            >
              <Button
                href={`${process.env.NEXT_PUBLIC_VENDORS_URL}register`}
                type="button"
                theme="tertiary"
              >
                Register
              </Button>
            </div>
          </div>{" "}
        </div>
      </div>
    </section>
  );
};

export default VendorsSection1;
